import React from 'react';
import ReactSpinner from 'react-bootstrap-spinner';
import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <div className="loading-spinner-container">
      <ReactSpinner type="border" color="primary" size="3" />
      <p className="loading-text">Se incarca...</p>
    </div>
  );
}

export default LoadingSpinner;

